














































































import { MedTransGoConstants } from '@/util/constants';
import { Component, Vue } from 'vue-property-decorator';
import { required, minLength, email, integer } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { ApiRequest } from '@/types/request';
import { ObjectFactory } from '@/config/objectFactory';
import { CommonUtils } from '@/util/commonUtils';
import { BillingContact, Organization, OrgLocation } from '@/types/entity';

@Component({
    mixins: [validationMixin],
    props: {
        organizationId: {
            type: String,
            required: true,
        },
        updateBillingContact: {
            type: Boolean,
            default: false,
        },
        billingContact: {
            type: Object,
            default: null,
        },
        locations: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            name: '',
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            title: '',
            id: null,
            billingLocationIds: [],
            managedLocations: [],
        };
    },
    validations() {
        const rules = {
            firstName: {
                required,
            },
            lastName: {
                required,
            },
            email: {
                required,
                email,
            },
            phone: {
                minLength: minLength(10),
            },
            managedLocations: {
                required,
                minLength: minLength(1),
            },
        };
        return rules;
    },
})

export default class AddBillingContactsModal extends Vue {
    private show = true;
    private orgLocations: OrgLocation[] = [];

    public async mounted() {
        await this.getOrgDetailsById();
        if (this.$props.billingContact && this.$props.updateBillingContact) {
            console.log('billingContact: ', this.$props.billingContact);
            this.$data.name = this.$props.billingContact.name;
            const nameParts = this.$props.billingContact.name.split(' ');
            this.$data.firstName = nameParts[0] || '';
            this.$data.lastName = nameParts.slice(1).join(' ') || '';
            this.$data.email = this.$props.billingContact.email;
            this.$data.phone = this.$props.billingContact.phone;
            this.$data.title = this.$props.billingContact.title;
            this.$data.id = this.$props.billingContact.id;
            this.$data.billingLocationIds =  this.$props.billingContact.billingLocationIds;
            this.$props.billingContact.billingLocationIds.forEach((id: string) => {
                const location = this.orgLocations.find((element) => element.id === id);
                if (location) {
                    this.$data.managedLocations.push(location);
                }
            });
        }
    }

    private close() {
        this.$emit('close');
    }

    private async getOrgDetailsById() {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${this.$props.organizationId}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<Organization>(apiRequest);
        if (response.success && response.data) {
            this.orgLocations = (response.data.locations || []).sort((a, b) =>
                (a.locationName || '').localeCompare(b.locationName || ''),
            );
        } else {
            this.orgLocations = [];
        }
    }

    private async editBillingContact() {
        const iHttpService = ObjectFactory.getHttpService();
        const organizationId = this.$props.organizationId;
        const billingContact: BillingContact = {
            billingLocationIds: [],
            id: this.$data.id,
            email: this.$data.email,
            name: this.$data.firstName + ' ' + this.$data.lastName,
            phone: this.$data.phone,
            title: this.$data.title,
        };
        this.$data.managedLocations.forEach((location: OrgLocation) => {
            billingContact.billingLocationIds.push(location.id);
        });

        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${organizationId}/billingContact`,
            data: billingContact,
            loaderEvent: {
                show: true,
            },
        };

        await iHttpService.put<any>(apiRequest);

        this.close();
        this.$emit('billingContactAdded');
    }



private async addBillingContact() {
    const iHttpService = ObjectFactory.getHttpService();
    const organizationId = this.$props.organizationId;
    const billingContact: BillingContact = {
        billingLocationIds: [],
        email: this.$data.email,
        name: this.$data.firstName + ' ' + this.$data.lastName,
        phone: this.$data.phone,
        title: this.$data.title,
    };
    this.$data.managedLocations.forEach((location: OrgLocation) => {
        billingContact.billingLocationIds.push(location.id);
    });
    const apiRequest: ApiRequest = {
        baseURL: this.$store.state.serverUrl,
        url: `${MedTransGoConstants.HTTP_URL_ORGANIZATIONS}/${organizationId}/billingContact`,
        data: billingContact,
        loaderEvent: {
            show: true,
        },
    };
    await iHttpService.put<any>(apiRequest);

    this.close();
    this.$emit('billingContactAdded');
}
    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }

    private async handleSubmit() {
        if (this.$props.updateBillingContact) {
            await this.editBillingContact();
        } else {
            await this.addBillingContact();
        }
    }
}

